import React, { useState, useEffect, Component, Fragment } from "react";
import '../ServicePopup.css';
const SERVICES_URL = process.env.REACT_APP_API_URL + "/searchallservice";

export default function ServicePopup({ mobile, open_service_popup, close_serivce_popup, pid,gid,conversation_id }) {
    const [serviceData, setServiceData] = useState([]);
    useEffect(() => {
        const req=fetch(
            SERVICES_URL + "?groupId=" + gid + "&propertyId=" + pid + "&languageCode=en",
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        req.then((m) => {
            m.json().then((k) => {
                var services=k.result.filter((i)=>i.status==="Active");
              setServiceData(services);
            });
          });
    }, [pid]);
      /**
  * Posts a message to the parent window, if this window has one
  * @param {*} msg
  */
       const postMessage = (msg) => {
        if (window.parent) {
            window.parent.postMessage(msg, "*");
        }
    }
    const handleClickDetail=(id)=>{
        let service_view_url=process.env.REACT_APP_SERVICE_VIEW_URL+"/serviceview";
        let url=`${service_view_url}?gid=${gid}&pid=${pid}&sid=${id}&conversation_id=${conversation_id}&mobile=${mobile}&open=0&custom=1`;
        postMessage("openServiceView:"+JSON.stringify(url));
    }
   
    return (
        <Fragment>
           <div className="service_view_popup">
                    <div className={`service_popup ${mobile === "true" ? "" : ""} ${open_service_popup ? "area" : "closepop"}`}>
                        <div
                            className={
                                mobile == "true"
                                    ? `service_popup_header chat_header_mobile`
                                    : `service_popup_header`
                            }
                            style={{ backgroundColor: "white" }}
                        >
                            <button
                            type='button'
                    aria-label="close Service"
                                className="service_header_icon list-button"
                                onClick={close_serivce_popup}
                            >
                                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"
                                    preserveAspectRatio="xMidYMid meet">
                                    <g transform="translate(0.000000,1060.000000) scale(0.100000,-0.100000)" stroke="none">
                                        <path d="M6216 10184 c-145 -35 15 118 -2514 -2408 -1712 -1711 -2337 -2342 -2352 -2373 -25 -52 -26 -145 -4 -199 11 -29 364 -387 1352 -1377 2312 -2315 3350 -3340 3409 -3371 202 -102 450 -61 612 101 38 38 80 91 94 118 79 157 79 331 0 490 -20 40 -437 463 -2066 2093 l-2042 2042 2036 2038 c1368 1368 2046 2053 2064 2085 93 162 88 377 -13 533 -121 187 -357 281 -576 228z" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <div className="service_popup_body">
                            <p className="text-left">Hi there, Here's some personality curated options for you.</p>
                            <div className={`popup_services ${mobile == "true"
                                ? "popup_items_mobile"
                                : "popup_items"
                                } mt-4`}>
                                {serviceData.length === 0 ?
                                       <div id="spinner" className="container" style={{ height: "60vh" }} role="status" aria-live="polite" aria-label="Loading chat" >
                                         <div className="loading"></div> </div>
                                  :
                                    serviceData.map((item, index) => (
                                        <button type='button'
                    aria-label={item?.title} 
                     className="service_item list-button" key={index} onClick={() => handleClickDetail(item.id)}>
                                            <div className="service_item_image" style={{
                                                backgroundImage: item.imageLink !== "" ? "url(" + item.imageLink + ")" : "",
                                                backgroundPosition: "center",
                                                backgroundSize: "cover"
                                            }}>
                                                {item.imageLink === "" && (
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="green" width="25px" height={"25px"} viewBox="0 0 512 512">
                                                    <path d="M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"/>
                                                    </svg>
                                                )}
                                            </div>
                                            <div className="service_item_text">
                                                <p className="mb-1">{item.title}</p>
                                            </div>
                                        </button>
                                    ))}
                            </div>
                            <div className="service_popup_footer d-none">
                                <div className="service_social_media_icon">
                                    <button>
                                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                            width="20px" height="20px" viewBox="0 0 360.000000 363.000000"
                                            preserveAspectRatio="xMidYMid meet">
                                            <g transform="translate(0.000000,363.000000) scale(0.100000,-0.100000)" stroke="none">
                                                <path d="M1578 3595 c-542 -74 -1042 -431 -1297 -925 -260 -506 -266 -1074 -15 -1587 l65 -132 -156 -462 c-85 -254 -154 -464 -152 -466 2 -2 219 66 482 150 l479 154 101 -48 c569 -272 1251 -211 1769 160 116 82 286 250 376 369 233 311 350 664 350 1055 -1 280 -50 501 -170 754 -250 527 -753 896 -1333 978 -124 18 -368 18 -499 0z m544 -305 c482 -102 882 -436 1062 -888 284 -712 -29 -1518 -719 -1852 -207 -100 -397 -143 -630 -144 -251 0 -426 43 -662 160 l-151 75 -268 -85 c-148 -47 -271 -86 -276 -86 -4 0 34 120 84 268 l91 267 -48 74 c-295 456 -305 1051 -25 1524 133 226 361 441 592 558 138 70 321 127 473 148 109 15 364 5 477 -19z" />
                                                <path d="M1185 2707 c-43 -20 -138 -124 -169 -185 -59 -117 -72 -259 -35 -392 76 -279 406 -707 689 -895 136 -91 371 -194 536 -235 74 -19 93 -20 155 -11 124 20 233 74 303 151 63 70 100 246 59 282 -24 20 -328 181 -374 198 -51 18 -79 8 -121 -47 -75 -96 -144 -163 -169 -163 -32 0 -185 78 -265 136 -97 69 -187 157 -259 253 -69 91 -125 188 -125 216 0 9 28 48 63 86 62 70 96 121 97 148 0 15 -134 379 -155 421 -18 35 -25 37 -121 44 -57 5 -87 3 -109 -7z" />
                                            </g>
                                        </svg>Whatsapp</button>
                                    <button> <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                        width="20px" height="20px" viewBox="0 0 600.000000 600.000000"
                                        preserveAspectRatio="xMidYMid meet">

                                        <g transform="translate(0.000000,600.000000) scale(0.100000,-0.100000)" stroke="none">
                                            <path d="M2715 5889 c-410 -38 -849 -171 -1190 -360 -243 -136 -427 -272 -624 -464 -437 -424 -696 -931 -783 -1530 -17 -117 -17 -532 0 -640 78 -488 227 -846 510 -1224 96 -129 343 -383 467 -481 l80 -63 5 -512 5 -511 490 268 489 269 111 -25 c728 -168 1454 -85 2105 240 287 144 519 311 746 538 417 419 663 904 751 1483 23 155 23 518 0 678 -86 588 -360 1112 -803 1534 -448 427 -1020 696 -1670 786 -141 20 -541 28 -689 14z m110 -2061 c72 -73 186 -191 255 -263 68 -71 180 -187 248 -257 l124 -127 652 361 c358 198 676 374 706 391 l55 30 -41 -44 c-663 -708 -1533 -1629 -1539 -1629 -1 0 -166 174 -366 388 -199 213 -366 388 -369 390 -3 1 -287 -151 -631 -339 -343 -188 -662 -362 -709 -387 l-85 -46 35 42 c49 58 1524 1622 1530 1622 3 0 64 -60 135 -132z" />
                                        </g>
                                    </svg>
                                        Messenger</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </Fragment>
    )
}